export default __webpack_public_path__ + "static/9-82258d0c16043785ecda7818bab81c56.png";